// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, post, request } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface CreateCustomerReferenceNumberApiParameter extends ApiParameter {
    customerId: string;
    productId: string;
    referenceNumber: string;
}

export interface UpdateCustomerReferenceNumberApiParameter extends ApiParameter {
    oldReferenceNumber: string;
    newReferenceNumber: string;
    productId: string;
}

export interface DeleteCustomerReferenceNumberApiParameter extends ApiParameter {
    productId: string;
    referenceNumber: string;
}

export interface LoadCustomerReferenceNumbersApiParameter extends ApiParameter {
    billToId: string;
}

interface CustomerReferenceNumbersModel {
    lastUpdatedOn: string;
    refNumber: string;
    productErpNumber: string;
    productMfgNumber: string;
    customerNumber: string;
    shipToCustomerName: string;
}

export interface ProductReferenceNumberCollection extends BaseModel {
    productReferenceNumberCollection: CustomerReferenceNumbersModel[];
}

const serviceUri = "api/mcmc/productReferenceNumber";

export async function getCustomerReferenceNumbers(parameter: LoadCustomerReferenceNumbersApiParameter) {
    const references = await get<ProductReferenceNumberCollection>(`${serviceUri}/${parameter.billToId}`);
    return references;
}

export function getExportUrl(parameter: LoadCustomerReferenceNumbersApiParameter) {
    const fileUrl = `${serviceUri}/exportToExcel/${parameter.billToId}`;
    return fileUrl;
}

export async function createCustomerReferenceNumber(parameter: CreateCustomerReferenceNumberApiParameter) {
    const result = await post<CreateCustomerReferenceNumberApiParameter>(`${serviceUri}`, parameter);
    return result;
}

export async function updateCustomerReferenceNumber(parameter: UpdateCustomerReferenceNumberApiParameter) {
    const result = await request(
        serviceUri,
        "PATCH",
        { "Content-Type": "application/json" },
        JSON.stringify(parameter),
    );
    return result;
}

export async function deleteCustomerReferenceNumber(parameter: DeleteCustomerReferenceNumberApiParameter) {
    const result = await request(
        `${serviceUri}?ReferenceNumber=${parameter.referenceNumber}&ProductId=${parameter.productId}`,
        "DELETE",
        { "Content-Type": "application/json" },
    );
    return result;
}
